import { VERIFY_USER_EMAIL } from '../Types';

const verifyUserEmail = (verificationToken) => {
  return (dispatch) => {
    const action = {
      type: VERIFY_USER_EMAIL,
      request: async (apiClient) => {
        await apiClient.user.verifyEmail({ verificationToken });
        return true;
      },
    };

    dispatch(action);
  };
};

export default verifyUserEmail;
